import React from 'react';
import { Box, alpha, CardHeader, CardContent } from '@mui/material';
import { COLORS, ModernCard, StatusTile } from '../../../../pages/Organisation/DailyUpdates/utils';

const AdmissionsOfficerSkeleton = () => {
	return (
		<Box
			sx={{
				p: 3,
				maxWidth: '1400px',
				margin: '0 auto',
				backgroundColor: alpha(COLORS.neutral, 0.5),
				borderRadius: '24px'
			}}
		>
			<Box sx={{ display: 'flex', gap: 3, mb: 4 }}>
				<ModernCard sx={{ flex: 1 }}>
					<CardHeader>
						<Box sx={{ width: '60%', height: '24px', bgcolor: COLORS.neutralDark, borderRadius: 1 }} />
						<Box
							sx={{ width: '40%', height: '16px', bgcolor: COLORS.neutralDark, borderRadius: 1, mt: 1 }}
						/>
					</CardHeader>
					<CardContent sx={{ p: 3 }}>
						<Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
							{[1, 2, 3, 4].map((index) => (
								<Box key={index}>
									<Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
										<Box
											sx={{
												width: '30%',
												height: '16px',
												bgcolor: COLORS.neutralDark,
												borderRadius: 1
											}}
										/>
										<Box
											sx={{
												width: '15%',
												height: '24px',
												bgcolor: COLORS.neutralDark,
												borderRadius: 1
											}}
										/>
									</Box>
									<Box
										sx={{
											width: '100%',
											height: '8px',
											bgcolor: COLORS.neutralDark,
											borderRadius: 1
										}}
									/>
								</Box>
							))}
						</Box>
					</CardContent>
				</ModernCard>

				<ModernCard sx={{ flex: 1 }}>
					<CardHeader>
						<Box sx={{ width: '60%', height: '24px', bgcolor: COLORS.neutralDark, borderRadius: 1 }} />
						<Box
							sx={{ width: '40%', height: '16px', bgcolor: COLORS.neutralDark, borderRadius: 1, mt: 1 }}
						/>
					</CardHeader>
					<CardContent sx={{ p: 3 }}>
						<Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
							{[1, 2, 3].map((index) => (
								<Box key={index}>
									<Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
										<Box
											sx={{
												width: '30%',
												height: '16px',
												bgcolor: COLORS.neutralDark,
												borderRadius: 1
											}}
										/>
										<Box
											sx={{
												width: '15%',
												height: '24px',
												bgcolor: COLORS.neutralDark,
												borderRadius: 1
											}}
										/>
									</Box>
									<Box
										sx={{
											width: '100%',
											height: '8px',
											bgcolor: COLORS.neutralDark,
											borderRadius: 1
										}}
									/>
								</Box>
							))}
						</Box>
					</CardContent>
				</ModernCard>
			</Box>

			<Box sx={{ mb: 4 }}>
				<Box sx={{ display: 'flex', gap: 3, mb: 4 }}>
					<StatusTile color={COLORS.primary} sx={{ flex: 1 }}>
						<Box
							sx={{ width: '70%', height: '16px', bgcolor: COLORS.neutralDark, borderRadius: 1, mb: 1 }}
						/>
						<Box
							sx={{ width: '40%', height: '32px', bgcolor: COLORS.neutralDark, borderRadius: 1, mb: 1 }}
						/>
						<Box sx={{ width: '60%', height: '13px', bgcolor: COLORS.neutralDark, borderRadius: 1 }} />
					</StatusTile>

					<StatusTile color={COLORS.success} sx={{ flex: 1 }}>
						<Box
							sx={{ width: '70%', height: '16px', bgcolor: COLORS.neutralDark, borderRadius: 1, mb: 1 }}
						/>
						<Box
							sx={{ width: '40%', height: '32px', bgcolor: COLORS.neutralDark, borderRadius: 1, mb: 1 }}
						/>
						<Box sx={{ width: '60%', height: '13px', bgcolor: COLORS.neutralDark, borderRadius: 1 }} />
					</StatusTile>
				</Box>
			</Box>
		</Box>
	);
};

export default AdmissionsOfficerSkeleton;
